<template slot-scope="scope">
  <!-- 知识产权服务 办理 弹窗 -->
  <div>
    <dialogModel
      title="提交一项"
      subtitle="（订单开始时，会有专门工作人员向你联系）"
      width="1200px"
      :visible.sync="VisibleHandlePro"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <div class="Select-Con">
          <template v-for="item in BusinessArr">
            <div
              v-if="item.ShowHide == true"
              :key="'biz-tab-' + item.id"
              class="tab-item"
              :class="{ 'tab-active': Business == item.id }"
              @click="handelBusiness(item)"
            >
              {{ item.name }}
            </div>
          </template>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <div class="section-row">
            <div class="section-block section-left">
              <div class="section-title">企业信息</div>
              <el-form-item
                label="企业名称："
                prop="companyName"
                :required="true"
              >
                <el-select
                  v-model="ruleForm.companyName"
                  placeholder="请选择企业名称"
                  @change="handelChange"
                  value-key="companyName"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码："
                prop="customerCreditCode"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.customerCreditCode }}</div>
              </el-form-item>
              <el-form-item
                label="法定代表人(负责人)："
                prop="legalPerson"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.legalPerson }}</div>
              </el-form-item>
              <el-form-item
                label="企业类型："
                prop="customerCompanyType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerCompanyType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerCompanyType')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="纳税类型："
                prop="customerTaxType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerTaxType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerTaxType')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="联系电话："
                prop="Telephone"
                :required="true"
              >
                <el-input maxlength="30"
                  v-model="ruleForm.Telephone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </div>

            <div class="section-block section-right">
              <div class="section-title">服务信息</div>
              <el-form-item label="服务类别：" :required="true" v-if="Business == 0">
                <el-radio-group
                  v-model="Application"
                  @change="onApplicationChange"
                >
                  <template v-for="item in ApplicationArr">
                    <el-radio
                      v-if="item.ShowHide == true"
                      :key="'app-' + item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="服务类别：" :required="true" v-if="Business == 1">
                <el-radio-group v-model="Renewal" @change="onRenewalChange">
                  <template v-for="item in RenewalArr">
                    <el-radio
                      v-if="item.ShowHide == true"
                      :key="'ren-' + item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="著作权名称："
                prop="WorkName"
                :required="true"
                v-if="Business == 0 && Application == 1"
              >
                <el-input maxlength="30"
                  v-model="ruleForm.WorkName"
                  placeholder="请输入著作权名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="专利名称："
                prop="PatentName"
                :required="true"
                v-if="
                  (Business == 0 && Application == 2) ||
                  (Business == 1 && Renewal == 1)
                "
              >
                <el-input maxlength="30"
                  v-model="ruleForm.PatentName"
                  placeholder="请输入专利名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="商标类型："
                :required="true"
                v-if="
                  (Business == 0 && Application == 0) ||
                  (Business == 1 && Renewal == 0)
                "
              >
                <el-radio-group
                  v-model="TrademarkType"
                  @change="onTrademarkTypeChange"
                >
                  <el-radio
                    v-for="item in Arr3"
                    :key="'tm-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="商标图标："
                prop="TXurl"
                :required="true"
                class="upload-item"
                v-if="
                  (Business == 0 && Application == 0 && TrademarkType == 1) ||
                  (Business == 1 && Renewal == 0 && TrademarkType == 1)
                "
              >
                <div class="Upload-box" v-loading="loading">
                  <img
                    class="firm-clickable"
                    :src="ruleForm.TXurl"
                    alt=""
                    v-if="ruleForm.TXurl != ''"
                    @click="clickFile()"
                  />
                  <input
                    type="file"
                    ref="clearFile"
                    @change="onFileChange"
                    id="file"
                  />
                  <input
                    type="button"
                    value="+"
                    class="btn firm-clickable"
                    @click="clickFile()"
                    v-if="ruleForm.TXurl == ''"
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="商标名称："
                prop="TrademarkName"
                :required="true"
                v-if="
                  (Business == 0 && Application == 0 && TrademarkType == 0) ||
                  (Business == 1 && Renewal == 0 && TrademarkType == 0)
                "
              >
                <el-input maxlength="30"
                  v-model="ruleForm.TrademarkName"
                  placeholder="请输入商标名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="经营范围：" prop="Scope" :required="true">
                <el-input
                  type="textarea"
                  class="textarea-md"
                  placeholder="请输入经营范围"
                  v-model="ruleForm.Scope"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                  :rows="4"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>

          <div class="section-block section-bottom">
            <div class="remark-row">
              <span class="remark-label">备注：</span>
              <div class="remark-box">
                <el-input
                  type="textarea"
                  class="textarea-lg"
                  placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
                  v-model="ruleForm.textarea"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                  :rows="5"
                >
                </el-input>
              </div>
            </div>
            <el-form-item label="支付方式：">
              <el-radio-group v-model="payType">
                <el-radio
                  v-for="item in payTypeArr"
                  :key="'pay-' + item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="14"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../../Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";
export default {
  props: {
    VisibleHandlePro: {},
    options1: {}, //平台企业的客户
    enterprise: {}, //平台企业的信息

    BusinessArr: {}, // 很据后端接口过滤出需要展示的 办理选项
    ApplicationArr: {}, // 很据后端接口过滤出需要展示的 服务选项
    RenewalArr: {}, // 很据后端接口过滤出需要展示的 服务选项
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      loading: false,
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择 //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",

      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 1, name: "个体户" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 4, name: "其他" },
      ], //企业类型选项
      Arr3: [
        { id: 0, name: "名称" },
        { id: 1, name: "图标" },
      ], //是否代理开户选项

      Application: "", //0商标 1著作权 2专利    申请
      Renewal: "", //0商标 1专利  展期
      Business: "", // 申请//展期
      TrademarkType: 0, //商标类型 0名称 1图标
      ruleForm: {
        customerCompanyType: null, //企业类型
        customerTaxType: null, //纳税类型
        companyName: "", //企业名称
        customerCreditCode: "", //企业统一信用代码
        customerCompanyAddress: "", //企业地址
        legalPerson: "", //法人

        Telephone: "", //联系电话
        Scope: "", //经营范围
        textarea: "", //备注

        TrademarkName: "", //商标名称
        WorkName: "", //著作名称
        PatentName: "", //专利名称

        TXurl: "", //上传到腾讯云的地址
      }, // 注销数据绑定
      rules: {
        // 规则未完善
        customerCompanyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        customerTaxType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        companyName: [
          {
            required: true,
            message: "请选择企业",
            trigger: ["blur", "change"],
          },
        ],
        customerCreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "法人姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        Telephone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],

        TrademarkName: [
          {
            required: true,
            message: "图标未上传",
            trigger: ["blur", "change"],
          },
        ],
        TXurl: [
          {
            required: true,
            message: "请上传图标",
            trigger: ["blur", "change"],
          },
        ],
        Scope: [
          {
            required: true,
            message: "请输入经营范围",
            trigger: ["blur", "change"],
          },
        ],
        WorkName: [
          {
            required: true,
            message: "请输入著作权名称",
            trigger: ["blur", "change"],
          },
        ],
        PatentName: [
          {
            required: true,
            message: "请输入专利名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证

      imageUrl: "", // 头像路径
      imgSrc: "",
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  computed: {},
  created() {},
  watch: {
    VisibleHandlePro: {
      handler(newSs, old) {
        if (newSs == true) {
          this.Business = this.BusinessArr[0].ShowHide == false ? 1 : 0;
          for (var i in this.RenewalArr) {
            if (this.RenewalArr[i].ShowHide === true) {
              this.Renewal = this.RenewalArr[i].id;
              break; // 找到第一个后立即退出循环，提升效率
            }
          }
          for (var i in this.ApplicationArr) {
            if (this.ApplicationArr[i].ShowHide === true) {
              this.Application = this.ApplicationArr[i].id;
              break; // 找到第一个后立即退出循环，提升效率
            }
          }
        } else {
          this.ClearOut();
        }
      },
      immediate: false,
    },
  },
  methods: {
    ClearOut() {
      this.ruleForm = {
        customerCompanyType: null, //企业类型
        customerTaxType: null, //纳税类型
        companyName: "", //企业名称
        customerCreditCode: "", //企业统一信用代码
        customerCompanyAddress: "", //企业地址
        legalPerson: "", //法人

        Telephone: "", //联系电话
        Scope: "", //经营范围
        textarea: "", //备注

        TrademarkName: "", //商标名称
        WorkName: "", //著作名称
        PatentName: "", //专利名称

        TXurl: "", //上传到腾讯云的地址
      }; //填写的内容
      this.EnterpriseIsItOptional = true;
      this.PayTaxesIsItOptional = true;
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 10);
    },
    handelTrademarkType(item) {
      this.ruleForm.TrademarkName = "";
      this.ruleForm.TXurl = "";
      this.imgSrc = "";
      this.$refs.ruleForm.validateField("TrademarkName");
      this.$refs.ruleForm.validateField("TXurl");
      this.TrademarkType = item.id;
    },
    onTrademarkTypeChange(id) {
      const item = (this.Arr3 || []).find((i) => i.id === id) || { id };
      this.handelTrademarkType(item);
    },
    handelBusiness(item) {
      this.ClearOut();
      this.Business = item.id;
    },
    onBusinessChange(id) {
      const item = (this.BusinessArr || []).find((i) => i.id === id);
      if (item) this.handelBusiness(item);
    },
    handelApplication(item) {
      this.ClearOut();
      this.Application = item.id;
    },
    onApplicationChange(id) {
      const item = (this.ApplicationArr || []).find((i) => i.id === id);
      if (item) this.handelApplication(item);
    },
    handelRenewal(item) {
      this.ClearOut();
      this.Renewal = item.id;
    },
    onRenewalChange(id) {
      const item = (this.RenewalArr || []).find((i) => i.id === id);
      if (item) this.handelRenewal(item);
    },
    //选择购买方
    handelChange(val) {
      this.EnterpriseIsItOptional= true //企业类型是否可选
      this.PayTaxesIsItOptional =  true //纳税类型是否可选
      console.log(val, this.ruleForm.Purchaser, "val");
      this.ruleForm.companyName = val.companyName;
      this.ruleForm.customerCreditCode = val.customerCreditCode;

      this.ruleForm.legalPerson = val.legalPerson;
      this.ruleForm.Telephone = val.phone;
      this.ruleForm.customerCompanyType = val.customerCompanyType;
      this.ruleForm.customerTaxType = val.customerTaxType;
      this.ruleForm.customerCompanyAddress = val.customerCompanyAddress;

      this.$refs.ruleForm.clearValidate();
      if (val.customerCompanyType !== null && val.customerCompanyType !== "") {
        // 自动选中企业类型，不可在修改
        this.EnterpriseIsItOptional = false;
      }
      if (val.customerTaxType !== null && val.customerTaxType !== "") {
        // 自动选中纳税类型，不可在修改
        this.PayTaxesIsItOptional = false;
      }
    },
    // 上传
    clickFile() {
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    async onFileChange(event, opt, callback) {
      this.loading = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1];
      if (
        fileSuffix == "png" ||
        fileSuffix == "jpeg" ||
        fileSuffix == "jpg" ||
        fileSuffix == "gif" ||
        fileSuffix == "webp" ||
        fileSuffix == "bmp"
      ) {
        let URL = window.URL || window.webkitURL; // 当前地址

        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        console.log(arr, "arr");
        if (arr.code == 0) {
          this.loading = false;
          this.imgSrc = URL.createObjectURL(file); // 转成 blob地址
          this.ruleForm.TXurl = arr.TXurl;
          this.$emit("handleAvatarTxUrl", this.ruleForm.TXurl);
          this.$refs.ruleForm.validateField("TXurl");
        } else {
          this.loading = false;
        }
        this.$refs.clearFile.value = ""; // 清空file文件
      } else {
        this.loading = false;
        // 上传文件不符合要求
        this.$tool.PromptBox("error", "请上传图片格式的文件");
      }
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseHandlePro");
    },
    // 确认
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (localStorage.getItem("PaymentPwd") == "false") {
            //没有开启支付密码验证直接弹支付二维码
            this.handleUnderstandPwd();
          } else {
            // 支付密码验证
            this.VisiblePwd = true;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      if (
        (this.Business == 0 && this.Application == 0) ||
        (this.Business == 1 && this.Renewal == 0)
      ) {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              trademarkList: [
                {
                  orderCompanyName: this.ruleForm.companyName, //需办理企业名称
                  orderCreditCode: this.ruleForm.customerCreditCode, //统一社会信用代码
                  orderLegalPerson: this.ruleForm.legalPerson, //法人姓名
                  orderCompanyPhone: this.ruleForm.Telephone, //联系电话
                  itemType: this.TrademarkType, //图标类型 0 名称 1图标
                  itemContent:
                    this.TrademarkType == 0
                      ? this.ruleForm.TrademarkName
                      : this.ruleForm.TXurl, //名称/图片地址
                  orderTaxType: this.ruleForm.customerTaxType, //纳税类型0 小规模 1一般纳税人
                  orderCompanyType: this.ruleForm.customerCompanyType, //服务类别0有限公司/1个体户/2子公司/3分公司/4其他
                  operationType: this.Business, //服务类型 0申请 1展期
                  businessScope: this.ruleForm.Scope, //经营范围
                  remark: this.ruleForm.textarea,
                },
              ],
            },
          },
        };
      } else if (this.Business == 0 && this.Application == 1) {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              copyrightList: [
                {
                  orderCompanyName: this.ruleForm.companyName, //需办理企业名称
                  orderCreditCode: this.ruleForm.customerCreditCode, //统一信用代码
                  orderLegalPerson: this.ruleForm.legalPerson, //法人
                  orderCompanyPhone: this.ruleForm.Telephone, //联系电话
                  itemContent: this.ruleForm.WorkName, //著作权名称
                  orderTaxType: this.ruleForm.customerTaxType, //纳税人类型
                  orderCompanyType: this.ruleForm.customerCompanyType, //企业类型
                  businessScope: this.ruleForm.Scope, //经营范围
                  remark: this.ruleForm.textarea, //备注
                },
              ],
            },
          },
        };
      } else if (
        (this.Business == 0 && this.Application == 2) ||
        (this.Business == 1 && this.Renewal == 1)
      ) {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              patentList: [
                {
                  orderCompanyName: this.ruleForm.companyName, //企业名
                  orderCreditCode: this.ruleForm.customerCreditCode, //信用代码
                  orderLegalPerson: this.ruleForm.legalPerson, //法人名
                  orderCompanyPhone: this.ruleForm.Telephone, //电话
                  itemContent:
                    this.TrademarkType == 0
                      ? this.ruleForm.TrademarkName
                      : this.ruleForm.TXurl, //专利名称
                  orderTaxType: this.ruleForm.customerTaxType, //纳税人类型
                  orderCompanyType: this.ruleForm.customerCompanyType, //企业类型
                  operationType: this.Business, //操作类型0申请1展期
                  businessScope: this.ruleForm.Scope, //经营范围
                  remark: this.ruleForm.textarea,
                },
              ],
            },
          },
        };
      }

      pay(data).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;
          this.VisiblePwd = false;
          // this.$emit("handleConfirmUp");
          // 打开二维码弹窗
          this.VisiblePayment = true;
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../Bookkeeping/components/bookkeeping-form-dialog.less";

.Select-Con {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 0 0 24px;
  border-bottom: 1px solid #edeff2;
  .tab-item {
    min-width: 96px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    margin: 0 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    font-size: 14px;
    color: #666666;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
  }
  .tab-active {
    color: #409eff;
    background: transparent;
    border-bottom: 2px solid #409eff;
  }
}

.Upload-box {
  width: 90px;
  height: 90px;
  border: 1px dashed #409eff;
  display: flex;
  margin-bottom: 8px;
  img {
    width: 100%;
    height: 100%;
  }
  #file {
    display: none;
  }
  input {
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    width: 100%;
    text-align: center;
    color: #409eff;
    margin: auto 0;
    font-size: 26px;
  }
}
</style>
